<template>
  <div class="cart__fixed">
    <div
      class="grid__column grid__column--4 grid__column--right grid__column--leftpad-biggest cart__order-last"
    >
      <table class="order-totals">
        <tbody>
          <tr class="order-totals__last order-totals__total">
            <th>{{ $t('order_total') }}:</th>
            <td>
              <span
                v-if="summary.itemTotal > summary.total"
                class="order-totals__fixed-subtotal"
              >
                {{ formatPrice(summary.itemTotal) }}</span
              >
              <span class="order-totals__fixed-total">
                {{ formatPrice(summary.total) }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>

      <v-button
        :label="$t('cart.cart_checkout')"
        type="submit"
        class="btn btn--large btn--block cart__totals-checkout"
        color="green"
        @click="handleCheckoutClick"
      />
      <div>
        <nuxt-link to="/" class="cart-mobile-products-link">
          <p class="cart-mobile-products-text">
            {{ $t('choose_more_products') }}
          </p>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
import priceable from '~/mixins/priceable'
import VButton from '~/components/v-button/VButton.vue'
import checkoutable from '~/mixins/checkoutable'

export default {
  name: 'NewCartMobileFinalizeBtn',
  components: {
    VButton,
  },
  mixins: [priceable, checkoutable],
  props: {
    summary: {
      type: Object,
      default: null,
    },
    cart: {
      type: Object,
      default: null,
    },
    hasOutOfStockItems: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCheckoutClick() {
      if (this.hasOutOfStockItems) {
        this.$emit('show-out-of-stock-modal')
      } else {
        this.goToCheckout()
      }
    },
  },
}
</script>

<style lang="scss">
.cart__fixed {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  padding: 15px 15px 5px 15px;
  border-top: 1px solid $v4_color_gray;
  background: white;

  .cart__line-divisor {
    display: none;
  }

  .coupon-code,
  .cart__shipping-code,
  .cart__shipping {
    display: none;
  }

  .cart__totals {
    border-top: 0;
    margin-bottom: 0;
    padding: 0;
    display: block;
  }

  .order-totals {
    margin: 0;
    border: 0;
    padding-top: 0;
    width: auto;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    justify-content: center;

    .order-totals__first {
      display: none;
    }
    tbody {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    th {
      padding-right: 2px;
    }
    td {
      padding: 0;
    }
  }
  .order-totals__fixed-subtotal {
    display: inline-block;
    text-decoration: line-through;
    font-weight: 400;
  }
  .order-totals__fixed-total {
    font-weight: 600;
    margin-left: 6px;
  }

  .cart__totals-checkout {
    width: 100%;
    margin: 0 auto;
    display: block;
  }

  .cart-mobile-products-link {
    color: inherit;
  }

  .cart-mobile-products-text {
    text-decoration: underline;
    text-align: center;
  }
}

.order-totals__fixed-subtotal {
  display: none;
}

.cart__aramex-available {
  text-align: center;
}
</style>
